export function ShamanPaymentsPage() {
  return (
    <div className="card space-y-2 text-ink-muted">
      <h2 className="text-xl font-bold text-ink">결제(고객 입금) 설정</h2>
      <p>본인 토스페이먼츠 가맹점 키 입력 폼은 다음 단계에서 구현됩니다.</p>
    </div>
  );
}
